import { k as _arrayLikeToArray, m as _unsupportedIterableToArray, a as _objectSpread2, b as _objectWithoutProperties, h as useIsMotionReduced, T as ThemeContext, _ as _slicedToArray, B as BoxWithDeprecationWarning, n as getApplyForResponsiveSize, w as withTestId, u as useColorScheme, o as mapResponsive, r as reduceResponsive, d as AwesomeIcon, p as deprecate, s as splitLayoutProps, q as pickThemingProps, v as _defineProperty, e as ButtonWithDeprecationWarning, i as splitSystemProps, c as componentMessage, L as Loader, C as ColorSchemeProvider, x as makeThemeResponsive, P as Provider$1, t as theme$1 } from './Link-3817ac11.esm.js';
import { useContext, useState, useEffect, useMemo, useCallback, isValidElement, Children, cloneElement } from 'react';
import { forwardRef, Text, Code as Code$1, Heading as Heading$1, chakra, useCheckboxGroupContext, useMultiStyleConfig, Checkbox as Checkbox$1, Select as Select$1, InputGroup, InputLeftElement, Input, InputRightElement, NumberInput, PinInput, Radio, Switch, Textarea, CheckboxGroup, RadioGroup, Slider as Slider$1, AspectRatio, Center, Box, Container, Grid, HStack, SimpleGrid, Spacer, Stack, VStack, Wrap, omitThemingProps, useFormControlContext, StylesProvider, FormLabel, RequiredIndicator, FormHelperText, FormControl, useNumberInput, Editable, EditableInput, EditableTextarea, EditablePreview, useStyles, Tabs, TabList, TabPanels, Tab, TabPanel, useMenuButton, MenuList, Menu as Menu$1, Portal, MenuButton as MenuButton$1, MenuItemOption as MenuItemOption$1, MenuCommand, MenuDivider, MenuGroup, MenuIcon, MenuItem, MenuOptionGroup, ModalOverlay, ModalHeader, ModalBody, ModalCloseButton, ModalFooter, Drawer as Drawer$1, DrawerContent, useControllableState, useModal, ModalContextProvider, ModalFocusScope, Modal as Modal$1, ModalContent, Popover as Popover$1, PopoverTrigger, PopoverContent, PopoverArrow, PopoverCloseButton, PopoverHeader, PopoverBody, PopoverFooter, Tooltip as Tooltip$1, Image as Image$1, SliderTrack, SliderMark, SliderFilledTrack, SliderThumb, Badge as Badge$1, Alert, AlertDescription, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, Table, Tbody, Td, Tfoot, Th, Thead, Tr, Icon, Tag as Tag$1, TagLeftIcon, TagLabel, TagCloseButton, extendTheme, ChakraProvider } from '@chakra-ui/react';
import { motion as motion$1, AnimatePresence, MotionConfig } from 'framer-motion';
import { transitions, math, lighten } from 'polished';
import 'ramda/src/pick';
import { theme } from '@hover/chakra-theme';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import _omit from 'ramda/src/omit';
import _mapObjIndexed from 'ramda/src/mapObjIndexed';
import { css, Global, useTheme as useTheme$1 } from '@emotion/react';
import { textSizes } from '@hover/chakra-theme/components';
import { borderPresets, space, motion as motion$2, colors, legacyTypography } from '@hover/chakra-theme/foundation';
import { includes, invoke } from '@hover/utilities';
import '@chakra-ui/system';
import 'ramda/src/values';
import 'ramda/src/map';
import 'ramda/src/fromPairs';
import 'ramda/src/toPairs';
import 'ramda/src/join';
import 'ramda/src/identity';
import 'ramda/src/ifElse';
import 'ramda/src/split';
import 'ramda/src/concat';
import 'ramda/src/toLower';
import 'ramda/src/pipe';
import { cx } from '@chakra-ui/utils';
import { faChevronDown, faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import 'ramda/src/has';
import 'tiny-warning';
import { iFilter } from '@hover/icons';
import invariant from 'tiny-invariant';
import _lensPath from 'ramda/src/lensPath';
import _set from 'ramda/src/set';
import { size50, size75, size100 } from '@hover/tokens-size';
import { fontAdelleSans, fontAvenirNext, fontMonoLisa, fontOpenSans } from '@hover/tokens-typography';

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var _excluded$s = ["host"];
var ASSET_HOST = 'https://blueprint.hover.to/assets/typography/';

var fontStylesFactory = function fontStylesFactory(fn) {
  return function (_ref) {
    var host = _ref.host,
        rest = _objectWithoutProperties(_ref, _excluded$s);

    return (// @ts-ignore
      fn(_objectSpread2({
        host: host !== null && host !== void 0 ? host : ASSET_HOST
      }, rest))
    );
  };
};
/**
 * Outputs @font-face declarations for Adelle Sans font. Unlike the other font
 * styles factories, Adelle Sans has two variations: original and "shifted" on
 * account of the raised baseline Adelle has out of the box. The "shifted"
 * version will load alternative assets what have the baseline shifted down 100
 * units (in 1000 units-per-em space)
 *
 * @param host prefix for asset URL
 * @param isShifted whether to load "shifted" assets or not (defaults to true)
 */


var adelleSans = /*#__PURE__*/fontStylesFactory(function (_ref) {
  var host = _ref.host,
      _ref$isShifted = _ref.isShifted,
      isShifted = _ref$isShifted === void 0 ? true : _ref$isShifted;
  var suffix = isShifted ? '-hover' : '';
  return /*#__PURE__*/css("@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--light.otf) format('opentype');font-weight:300;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--light-italic.otf) format('opentype');font-weight:300;font-style:italic;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--regular.otf) format('opentype');font-weight:400;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--italic.otf) format('opentype');font-weight:400;font-style:italic;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--semi-bold.otf) format('opentype');font-weight:600;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--semi-bold-italic.otf) format('opentype');font-weight:600;font-style:italic;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--bold.otf) format('opentype');font-weight:700;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--bold-italic.otf) format('opentype');font-weight:700;font-style:italic;font-display:fallback;}" + (process.env.NODE_ENV === "production" ? "" : ";label:adelleSans;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
});
var avenirNext = /*#__PURE__*/fontStylesFactory(function (_ref) {
  var host = _ref.host;
  return /*#__PURE__*/css("@font-face{font-family:", fontAvenirNext, ";src:url(", host, "avenir-next--regular.ttf) format('truetype');font-weight:400;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAvenirNext, ";src:url(", host, "avenir-next--italic.ttf) format('truetype');font-weight:400;font-style:italic;font-display:fallback;}@font-face{font-family:", fontAvenirNext, ";src:url(", host, "avenir-next--medium.ttf) format('truetype');font-weight:500;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAvenirNext, ";src:url(", host, "avenir-next--medium-italic.ttf) format('truetype');font-weight:500;font-style:italic;font-display:fallback;}@font-face{font-family:", fontAvenirNext, ";src:url(", host, "avenir-next--demi.ttf) format('truetype');font-weight:600;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAvenirNext, ";src:url(", host, "avenir-next--demi-italic.ttf) format('truetype');font-weight:600;font-style:italic;font-display:fallback;}@font-face{font-family:", fontAvenirNext, ";src:url(", host, "avenir-next--bold.ttf) format('truetype');font-weight:700;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAvenirNext, ";src:url(", host, "avenir-next--bold-italic.ttf) format('truetype');font-weight:700;font-style:italic;font-display:fallback;}" + (process.env.NODE_ENV === "production" ? "" : ";label:avenirNext;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
});
var monoLisa = /*#__PURE__*/fontStylesFactory(function (_ref) {
  var host = _ref.host;
  return /*#__PURE__*/css("@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--light.ttf) format('truetype');font-weight:300;font-style:normal;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--light-italic.ttf) format('truetype');font-weight:300;font-style:italic;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--regular.ttf) format('truetype');font-weight:400;font-style:normal;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--regular-italic.ttf) format('truetype');font-weight:400;font-style:italic;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--medium.ttf) format('truetype');font-weight:500;font-style:normal;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--medium-italic.ttf) format('truetype');font-weight:500;font-style:italic;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--bold.ttf) format('truetype');font-weight:700;font-style:normal;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--bold-italic.ttf) format('truetype');font-weight:700;font-style:italic;font-display:fallback;}" + (process.env.NODE_ENV === "production" ? "" : ";label:monoLisa;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
});
var openSans = /*#__PURE__*/fontStylesFactory(function (_ref) {
  var host = _ref.host;
  return /*#__PURE__*/css("@font-face{font-family:", fontOpenSans, ";src:url(", host, "open-sans--light.ttf) format('truetype');font-weight:300;font-style:normal;font-display:fallback;}@font-face{font-family:", fontOpenSans, ";src:url(", host, "open-sans--light-italic.ttf) format('truetype');font-weight:300;font-style:italic;font-display:fallback;}@font-face{font-family:", fontOpenSans, ";src:url(", host, "open-sans--regular.ttf) format('truetype');font-weight:400;font-style:normal;font-display:fallback;}@font-face{font-family:", fontOpenSans, ";src:url(", host, "open-sans--italic.ttf) format('truetype');font-weight:400;font-style:italic;font-display:fallback;}@font-face{font-family:", fontOpenSans, ";src:url(", host, "open-sans--semi-bold.ttf) format('truetype');font-weight:600;font-style:normal;font-display:fallback;}@font-face{font-family:", fontOpenSans, ";src:url(", host, "open-sans--semi-bold-italic.ttf) format('truetype');font-weight:600;font-style:italic;font-display:fallback;}@font-face{font-family:", fontOpenSans, ";src:url(", host, "open-sans--bold.ttf) format('truetype');font-weight:700;font-style:normal;font-display:fallback;}@font-face{font-family:", fontOpenSans, ";src:url(", host, "open-sans--bold-italic.ttf) format('truetype');font-weight:700;font-style:italic;font-display:fallback;}@font-face{font-family:", fontOpenSans, ";src:url(", host, "open-sans--extra-bold.ttf) format('truetype');font-weight:800;font-style:normal;font-display:fallback;}@font-face{font-family:", fontOpenSans, ";src:url(", host, "open-sans--extra-bold-italic.ttf) format('truetype');font-weight:800;font-display:fallback;font-style:italic;}" + (process.env.NODE_ENV === "production" ? "" : ";label:openSans;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
});
var _excluded$r = ["includeNew", "includeLegacy"];

var Fonts = function Fonts(_ref) {
  var _ref$includeNew = _ref.includeNew,
      includeNew = _ref$includeNew === void 0 ? false : _ref$includeNew,
      _ref$includeLegacy = _ref.includeLegacy,
      includeLegacy = _ref$includeLegacy === void 0 ? true : _ref$includeLegacy,
      props = _objectWithoutProperties(_ref, _excluded$r);

  var commonFonts = [monoLisa(props)];
  var newFonts = [adelleSans(props)];
  var legacyFonts = [avenirNext(props), openSans(props)];
  return jsx(Global, {
    styles: /*#__PURE__*/css([].concat(commonFonts, _toConsumableArray(includeNew ? newFonts : []), _toConsumableArray(includeLegacy ? legacyFonts : [])), process.env.NODE_ENV === "production" ? "" : ";label:Fonts;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5QmMiLCJmaWxlIjoiRm9udHMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgR2xvYmFsLCBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBhZGVsbGVTYW5zIH0gZnJvbSAnLi9hZGVsbGVTYW5zJztcbmltcG9ydCB7IGF2ZW5pck5leHQgfSBmcm9tICcuL2F2ZW5pck5leHQnO1xuaW1wb3J0IHsgbW9ub0xpc2EgfSBmcm9tICcuL21vbm9MaXNhJztcbmltcG9ydCB7IG9wZW5TYW5zIH0gZnJvbSAnLi9vcGVuU2Fucyc7XG5pbXBvcnQgeyBGb250UHJvcHMgfSBmcm9tICcuL3R5cGVzJztcblxuZXhwb3J0IGludGVyZmFjZSBGb250c1Byb3BzIGV4dGVuZHMgRm9udFByb3BzIHtcbiAgaW5jbHVkZU5ldz86IGJvb2xlYW47XG4gIGluY2x1ZGVMZWdhY3k/OiBib29sZWFuO1xufVxuXG5jb25zdCBGb250cyA9ICh7XG4gIGluY2x1ZGVOZXcgPSBmYWxzZSxcbiAgaW5jbHVkZUxlZ2FjeSA9IHRydWUsXG4gIC4uLnByb3BzXG59OiBGb250c1Byb3BzKSA9PiB7XG4gIGNvbnN0IGNvbW1vbkZvbnRzID0gW21vbm9MaXNhKHByb3BzKV07XG4gIGNvbnN0IG5ld0ZvbnRzID0gW2FkZWxsZVNhbnMocHJvcHMpXTtcbiAgY29uc3QgbGVnYWN5Rm9udHMgPSBbYXZlbmlyTmV4dChwcm9wcyksIG9wZW5TYW5zKHByb3BzKV07XG5cbiAgcmV0dXJuIChcbiAgICA8R2xvYmFsXG4gICAgICBzdHlsZXM9e2NzcyhbXG4gICAgICAgIC4uLmNvbW1vbkZvbnRzLFxuICAgICAgICAuLi4oaW5jbHVkZU5ldyA/IG5ld0ZvbnRzIDogW10pLFxuICAgICAgICAuLi4oaW5jbHVkZUxlZ2FjeSA/IGxlZ2FjeUZvbnRzIDogW10pLFxuICAgICAgXSl9XG4gICAgLz5cbiAgKTtcbn07XG5cbmV4cG9ydCB7IEZvbnRzIH07XG4iXX0= */")
  });
};

var stylesToOmit = ['transform'];

var stripMotionFromVariants = function stripMotionFromVariants(variants, strip) {
  return _mapObjIndexed(function (variant) {
    return strip ? _omit(stylesToOmit, variant) : variant;
  }, variants);
};
/**
 * Framer Motion's `motion` factory with types
 * that work properly with system components
 */


var motion = function motion(Component) {
  return motion$1(Component);
};

var useReducedMotionVariants = function useReducedMotionVariants(variants) {
  var isMotionReduced = useIsMotionReduced();
  return stripMotionFromVariants(variants, isMotionReduced !== null && isMotionReduced !== void 0 ? isMotionReduced : false);
};

var useTheme = function useTheme() {
  if (process.env.NODE_ENV !== "production") // eslint-disable-next-line no-console
    console.warn(['The `useTheme` hook returns the legacy theme which will be replaced with', 'the Chakra theme in 1.0. Use `useChakraTheme` in place of `useTheme` to', 'ensure existing code is compatible with the Chakra theme.'].join(' '));
  return useContext(ThemeContext).theme;
};

var useChakraTheme = function useChakraTheme() {
  return useTheme$1();
};
/**
 * Returns a boolean flag that resets to `false` after the provided timeout
 *
 * @param timeout how long to wait before resetting flag
 */


var useTimeoutFlag = function useTimeoutFlag(timeout) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      flag = _useState2[0],
      setFlag = _useState2[1];

  useEffect(function () {
    if (!flag) return undefined;
    var id = setTimeout(function () {
      return setFlag(false);
    }, timeout);
    return function () {
      return clearTimeout(id);
    };
  }, [flag, timeout]);
  return [flag, setFlag];
};

var _excluded$q = ["children"];
var Panel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$q);

  return jsx(BoxWithDeprecationWarning, _objectSpread2(_objectSpread2({
    backgroundColor: "background",
    borderRadius: 300,
    flexDirection: "column",
    padding: 300
  }, props), {}, {
    ref: ref,
    children: children
  }));
});
Panel.displayName = 'Panel';
var _excluded$p = ["as", "children", "element", "isSemiBold", "isBold", "size"];
var Body = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
      children = _ref.children,
      element = _ref.element,
      _ref$isSemiBold = _ref.isSemiBold,
      isSemiBold = _ref$isSemiBold === void 0 ? false : _ref$isSemiBold,
      _ref$isBold = _ref.isBold,
      isBold = _ref$isBold === void 0 ? false : _ref$isBold,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 500 : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded$p);

  var getVariant = function getVariant() {
    if (isBold) return 'bold';
    if (isSemiBold) return 'semiBold';
    return 'default';
  };

  return jsx(Text, _objectSpread2(_objectSpread2({
    as: element !== null && element !== void 0 ? element : as
  }, withTestId(props)), {}, {
    apply: getApplyForResponsiveSize('Text', size),
    ref: ref,
    variant: getVariant(),
    children: children
  }));
});
Body.displayName = 'Body';
var _excluded$o = ["as", "children", "colorScheme", "size", "variant"];
var Code = /*#__PURE__*/forwardRef(function (_ref, ref) {
  _ref.as;

  var children = _ref.children,
      colorScheme = _ref.colorScheme,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 500 : _ref$size,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded$o);

  var _useColorScheme = useColorScheme(),
      contextColorScheme = _useColorScheme.colorScheme,
      contextVariant = _useColorScheme.variant;

  return jsx(Code$1, _objectSpread2(_objectSpread2({
    colorScheme: colorScheme !== null && colorScheme !== void 0 ? colorScheme : contextColorScheme,
    variant: variant !== null && variant !== void 0 ? variant : contextVariant
  }, withTestId(props)), {}, {
    apply: getApplyForResponsiveSize('Code', size),
    ref: ref,
    children: children
  }));
});
Code.displayName = 'Code';
var _excluded$n = ["children", "isDisplay", "isLight", "size"];
var elements = {
  200: 'h6',
  300: 'h5',
  400: 'h4',
  500: 'h3',
  600: 'h2',
  650: 'h2',
  700: 'h1',
  800: 'h1',
  900: 'h1'
};
var Heading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$isDisplay = _ref.isDisplay,
      isDisplay = _ref$isDisplay === void 0 ? false : _ref$isDisplay,
      _ref$isLight = _ref.isLight,
      isLight = _ref$isLight === void 0 ? false : _ref$isLight,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 600 : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded$n);

  var apply = getApplyForResponsiveSize('Heading', isDisplay ? mapResponsive(function (s) {
    return "display".concat(s);
  }, size) : size);
  var largestSize = reduceResponsive(function (acc, value) {
    return value && value > acc ? value : acc;
  }, 200, size);

  var getVariant = function getVariant() {
    if (isDisplay) return 'display';
    if (isLight) return 'light';
    return 'default';
  };

  return jsx(Heading$1, _objectSpread2(_objectSpread2({
    as: elements[largestSize],
    marginTop: "0"
  }, withTestId(props)), {}, {
    apply: apply,
    ref: ref,
    variant: getVariant(),
    children: children
  }));
});
Heading.displayName = 'Heading';
var _excluded$m = ["status", "content"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var MotionPanel = /*#__PURE__*/motion$1(Panel);
var MotionBody = /*#__PURE__*/motion$1(Body);
var themes = {
  danger: {
    color: 'danger800',
    backgroundColor: 'danger100'
  },
  success: {
    color: 'success800',
    backgroundColor: 'success100'
  },
  warning: {
    color: 'warning800',
    backgroundColor: 'warning100'
  }
};

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "17lxyek",
  styles: "p{position:absolute;}p:last-of-type{position:static;}"
} : {
  name: "1vxg1wd-Message",
  styles: "p{position:absolute;}p:last-of-type{position:static;};label:Message;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Message = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$status = _ref.status,
      status = _ref$status === void 0 ? 'danger' : _ref$status,
      content = _ref.content,
      props = _objectWithoutProperties(_ref, _excluded$m);

  var theme = useChakraTheme();
  return jsx(MotionPanel, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    display: "block"
  }, props), themes[status]), transitions(['background-color', theme.motion.easings[250]])), {}, {
    "aria-live": "assertive",
    css: _ref2,
    layout: true,
    overflow: "hidden",
    position: "relative",
    ref: ref,
    role: "alert",
    children: jsx(AnimatePresence, {
      initial: false,
      children: jsx(MotionBody, {
        animate: {
          opacity: 1,
          y: '0%'
        },
        color: "inherit",
        exit: {
          opacity: 0,
          y: '100%'
        },
        initial: {
          opacity: 0,
          y: '-100%'
        },
        margin: 0,
        size: 400,
        transition: theme.motion.framer.firm,
        children: content
      }, content)
    })
  }));
});
var _excluded$l = ["delay", "isChecked", "isDisabled", "isIndeterminate", "isInvalid", "variants"];
var MotionSvg = /*#__PURE__*/motion$1(chakra.svg);
var DASH_OFFSET_UNCHECKED = '43px';
var DASH_OFFSET_CHECKED = '3px';
var CHECKED_PATH = 'M2 15.556L12 25 30 8';
var INDETERMINATE_PATH = 'M2 16L12 16 30 16';
var pathVariants = {
  unchecked: {
    strokeDashoffset: DASH_OFFSET_UNCHECKED,
    strokeWidth: '6px',
    d: CHECKED_PATH
  },
  checked: {
    transition: {
      delay: 0
    },
    strokeDashoffset: DASH_OFFSET_CHECKED,
    strokeWidth: '6px',
    d: CHECKED_PATH
  },
  indeterminate: {
    strokeDashoffset: DASH_OFFSET_CHECKED,
    strokeWidth: '7px',
    d: INDETERMINATE_PATH
  }
}; // Update the delay for the `checked` variant of the above motion variants

var updateCheckedDelay = /*#__PURE__*/_set( /*#__PURE__*/_lensPath(['checked', 'transition', 'delay']));

var getVariant = function getVariant(_ref) {
  var isChecked = _ref.isChecked,
      isIndeterminate = _ref.isIndeterminate;
  if (isIndeterminate) return 'indeterminate';
  if (isChecked) return 'checked';
  return 'unchecked';
};

var Check = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var delay = _ref2.delay,
      isChecked = _ref2.isChecked,
      isDisabled = _ref2.isDisabled,
      isIndeterminate = _ref2.isIndeterminate,
      isInvalid = _ref2.isInvalid,
      variants = _ref2.variants,
      props = _objectWithoutProperties(_ref2, _excluded$l);

  var pathVariantsWithDelay = delay ? updateCheckedDelay(delay, pathVariants) : pathVariants;
  return jsx(MotionSvg // @ts-expect-error
  , _objectSpread2(_objectSpread2({
    transition: theme.motion.springs.firm,
    variants: variants
  }, props), {}, {
    animate: getVariant({
      isChecked: isChecked,
      isIndeterminate: isIndeterminate
    }),
    custom: {
      isInvalid: isInvalid,
      isDisabled: isDisabled
    },
    ref: ref,
    viewBox: "-4 -4 40 40",
    children: jsx(motion$1.path, {
      strokeDasharray: DASH_OFFSET_UNCHECKED,
      strokeLinejoin: "miter",
      variants: pathVariantsWithDelay
    })
  }));
});
var _excluded$k = ["children"];

var getCheckedBackground = function getCheckedBackground(_ref) {
  var isInvalid = _ref.isInvalid,
      isDisabled = _ref.isDisabled;
  if (isDisabled) return borderPresets.disabled.borderColor;
  if (isInvalid) return theme.colors.danger.base;
  return theme.colors.primary.base;
};

var backgroundVariants = {
  unchecked: function unchecked(_ref2) {
    var isDisabled = _ref2.isDisabled;
    return {
      transition: {
        delay: 0.1
      },
      background: isDisabled ? theme.colors.neutral[100] : theme.colors.neutral[0]
    };
  },
  checked: function checked(props) {
    return {
      background: getCheckedBackground(props)
    };
  },
  indeterminate: function indeterminate(props) {
    return {
      background: getCheckedBackground(props)
    };
  }
};
var Checkbox = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var _useCheckboxGroupCont;

  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded$k);

  var _ref4 = (_useCheckboxGroupCont = useCheckboxGroupContext()) !== null && _useCheckboxGroupCont !== void 0 ? _useCheckboxGroupCont : {},
      isGroupDisabled = _ref4.isDisabled;

  var isInvalid = props.isInvalid,
      _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? isGroupDisabled : _props$isDisabled;
  var styles = useMultiStyleConfig('Checkbox', props);
  var Icon = useMemo(function () {
    return function (_ref5) {
      var isChecked = _ref5.isChecked,
          isIndeterminate = _ref5.isIndeterminate;
      return jsx(Check, {
        __css: styles.icon,
        "data-testid": "icon",
        delay: 0.06,
        isChecked: isChecked,
        isDisabled: isDisabled,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        variants: backgroundVariants
      });
    };
  }, [styles.icon, isInvalid, isDisabled]);
  return jsx(Checkbox$1 // FIXME: Chakra sets `cursor` internally in a way that's
  // preventing us from controlling it from the theme
  , _objectSpread2(_objectSpread2({
    _disabled: {
      cursor: 'unset'
    },
    cursor: "unset"
  }, props), {}, {
    icon: jsx(Icon, {}, "blueprint-icon"),
    ref: ref,
    children: children
  }));
});
Checkbox.displayName = 'Checkbox';
var _excluded$j = ["children", "size", "iconSize"];

var iconSizeFor = function iconSizeFor(size) {
  switch (size) {
    case 'default':
      return size100;

    case 'small':
      return size75;

    case 'tiny':
      return size50;

    default:
      return null;
  }
};

var Select = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _iconSizeFor;

  var children = _ref.children,
      size = _ref.size,
      iconSize = _ref.iconSize,
      props = _objectWithoutProperties(_ref, _excluded$j);

  return jsx(Select$1, _objectSpread2(_objectSpread2({
    icon: jsx(AwesomeIcon, {
      icon: faChevronDown
    }),
    iconSize: (_iconSizeFor = iconSizeFor(size)) !== null && _iconSizeFor !== void 0 ? _iconSizeFor : iconSize,
    isTruncated: true,
    size: size
  }, props), {}, {
    ref: ref,
    children: children
  }));
});
Select.displayName = 'Select';
var TextInputType = {
  text: 'text',
  search: 'search',
  tel: 'tel',
  url: 'url',
  email: 'email',
  number: 'number',
  password: 'password',
  date: 'date',
  time: 'time',
  dateTime: 'datetime-local',
  month: 'month'
};
var TextInputMode = {
  text: 'text',
  search: 'search',
  tel: 'tel',
  url: 'url',
  email: 'email',
  numeric: 'numeric',
  decimal: 'decimal',
  none: 'none'
};
/* eslint-disable @typescript-eslint/no-redeclare */

var _excluded$i = ["disabled", "error", "iconAfter", "iconBefore", "isDisabled", "isInvalid", "label", "onBlur", "onFocus", "onValueChange", "mode", "type", "testId"];
var TextInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      iconAfter = _ref.iconAfter,
      iconBefore = _ref.iconBefore,
      isDisabledProp = _ref.isDisabled,
      isInvalidProp = _ref.isInvalid,
      label = _ref.label,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onValueChange = _ref.onValueChange,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? TextInputMode.text : _ref$mode,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? TextInputType.text : _ref$type,
      testId = _ref.testId,
      props = _objectWithoutProperties(_ref, _excluded$i);

  var isInvalid = isInvalidProp !== null && isInvalidProp !== void 0 ? isInvalidProp : error;
  var isDisabled = isDisabledProp !== null && isDisabledProp !== void 0 ? isDisabledProp : disabled;
  var _props$size = props.size,
      size = _props$size === void 0 ? 'default' : _props$size;

  var _splitLayoutProps = splitLayoutProps(props),
      layoutProps = _splitLayoutProps.layoutProps,
      inputProps = _splitLayoutProps.props;

  var inputGroupProps = _objectSpread2(_objectSpread2({}, layoutProps), pickThemingProps(props));

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var onElementFocus = function onElementFocus(event) {
    setFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  };

  var onElementBlur = function onElementBlur(event) {
    setFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  };

  var onElementChange = function onElementChange(event) {
    var _props$onChange;

    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(event.target.value);
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, event);
  };

  var renderIcon = useCallback(function (icon) {
    var color = focused ? 'secondary600' : 'neutral500';
    var errorColor = focused ? 'danger700' : 'danger500';
    return jsx(AwesomeIcon, {
      color: isInvalid ? errorColor : color,
      icon: icon,
      margin: 0,
      size: size === 'tiny' ? 'tiny' : 'small'
    });
  }, [focused, isInvalid, size]);
  return jsxs(InputGroup, _objectSpread2(_objectSpread2({}, withTestId(_objectSpread2(_objectSpread2({}, inputGroupProps), {}, {
    testId: testId
  }))), {}, {
    children: [iconBefore && jsx(InputLeftElement, {
      children: renderIcon(iconBefore)
    }), jsx(Input, _objectSpread2({
      "aria-label": label,
      inputMode: mode,
      isDisabled: isDisabled,
      isInvalid: isInvalid,
      onBlur: onElementBlur,
      onChange: onElementChange,
      onFocus: onElementFocus,
      ref: ref,
      type: type
    }, inputProps)), iconAfter && jsx(InputRightElement, {
      children: renderIcon(iconAfter)
    })]
  }));
});
TextInput.displayName = 'TextInput'; // TODO(1.0): 1.0 remove `initialValue` and `disabled` entirely

var TextInputWithDeprecationWarning = /*#__PURE__*/deprecate(process.env.NODE_ENV !== "production" && {
  error: 'the `error` prop is deprecated, use `isInvalid`',
  disabled: 'the `disabled` prop is deprecated, use `isDisabled`',
  onValueChange: 'the `onValueChange` prop is deprecated, use `onChange`'
}, TextInput);
/**
 * All layout primitives
 */

var layoutElements = [AspectRatio, BoxWithDeprecationWarning, Center, Box, Container, Grid, HStack, SimpleGrid, Spacer, Stack, VStack, Wrap];

var isIntrinsicElement = function isIntrinsicElement(element) {
  if (typeof element === 'string' || typeof element === 'number' || typeof element.type === 'string') return true;
  return false;
};
/**
 * Check if a child element is a layout element (`Box`, `Stack`, etc.)
 *
 * @param element child JSX node
 */


var isLayoutElement = function isLayoutElement(element) {
  if (! /*#__PURE__*/isValidElement(element)) return false;
  if (isIntrinsicElement(element)) return false;
  return includes(layoutElements, element.type);
};
/**
 * Subset of inputs that support an `isInvalid` state
 */


var invalidatableInputElements = [Input, NumberInput, PinInput, Radio, Select, Switch, TextInputWithDeprecationWarning, Textarea, Checkbox];
/**
 * Subset of inputs that already include a `<label />`
 */

var labeledInputElements = [CheckboxGroup, RadioGroup, Checkbox];
var inputElements = /*#__PURE__*/[].concat(invalidatableInputElements, labeledInputElements, [Slider$1]);
/**
 * Check if a child element is an input
 *
 * @param element child JSX node
 */

var isInputElement = function isInputElement(element) {
  if (! /*#__PURE__*/isValidElement(element)) return false;
  if (isIntrinsicElement(element)) return false;
  return includes(inputElements, element.type);
};

var isInvalidatableInputElement = function isInvalidatableInputElement(element) {
  if (!isInputElement(element)) return false;
  return includes(invalidatableInputElements, element.type);
};
/**
 * Check if a child element is an input element that includes a `<label />`
 *
 * @param element child JSX node
 */


var isLabeledInputElement = function isLabeledInputElement(element) {
  if (!isInputElement(element)) return false;
  return includes(labeledInputElements, element.type);
};

var MotionDiv = /*#__PURE__*/motion$1(chakra.div);
var FormErrorMessage = /*#__PURE__*/forwardRef(function (props, ref) {
  var styles = useMultiStyleConfig('FormError', props);
  var ownProps = omitThemingProps(props);
  var field = useFormControlContext();
  var variants = useReducedMotionVariants({
    valid: {
      opacity: 0,
      transform: 'translate3d(0, -100%, 0)'
    },
    invalid: {
      opacity: 1,
      transform: 'translate3d(0, 0%, 0)'
    }
  });
  return jsx(StylesProvider, {
    value: styles,
    children: jsx(AnimatePresence, {
      children: (field === null || field === void 0 ? void 0 : field.isInvalid) && // @ts-expect-error
      jsx(MotionDiv, _objectSpread2(_objectSpread2({}, field === null || field === void 0 ? void 0 : field.getErrorMessageProps(ownProps, ref)), {}, {
        __css: _objectSpread2({
          display: 'flex',
          alignItems: 'center'
        }, styles.text),
        animate: "invalid",
        className: cx('chakra-form__error-message', props.className),
        exit: "valid",
        initial: "valid",
        role: "alert",
        variants: variants
      }))
    })
  });
});
FormErrorMessage.displayName = 'FormErrorMessage';
var _excluded$h = ["autohide", "children", "disabled", "error", "isDisabled", "label", "name", "note", "requiredLabel"];
var spacingError = 100;
var spacingBottom = 200;
var paddingBottomInvalid = /*#__PURE__*/math( /*#__PURE__*/"".concat(space[spacingError], " + ").concat(textSizes[400].lineHeight, " + ").concat(space[spacingBottom]));
var MotionFormControl = /*#__PURE__*/motion$1(FormControl);
var invalidVariants = {
  valid: {
    paddingBottom: space[500]
  },
  invalid: {
    paddingBottom: paddingBottomInvalid
  }
};
var Field = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _props$id;

  _ref.autohide;

  var children = _ref.children,
      disabled = _ref.disabled,
      error = _ref.error,
      isDisabledProp = _ref.isDisabled,
      label = _ref.label,
      name = _ref.name,
      note = _ref.note,
      _ref$requiredLabel = _ref.requiredLabel,
      requiredLabel = _ref$requiredLabel === void 0 ? 'Required' : _ref$requiredLabel,
      props = _objectWithoutProperties(_ref, _excluded$h);

  var isDisabled = isDisabledProp !== null && isDisabledProp !== void 0 ? isDisabledProp : disabled;
  var child = Children.only(children);
  var id = (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : name;
  var isInvalid = !!error;
  var shouldDefaultPlaceholder = includes([TextInputWithDeprecationWarning, Input], child.type);
  var isLabeled = isLabeledInputElement(child);
  var supportsIsDisabled = isInputElement(child);
  var supportsIsInvalid = isInvalidatableInputElement(child);
  var isMotionReduced = useIsMotionReduced();

  var inputProps = _objectSpread2(_objectSpread2(_objectSpread2({}, supportsIsDisabled ? {
    isDisabled: isDisabled
  } : {}), supportsIsInvalid ? {
    isInvalid: isInvalid
  } : {}), {}, {
    id: id,
    name: name,
    placeholder: shouldDefaultPlaceholder ? label : undefined
  }, child.props);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  useEffect(function () {
    if (error) setErrorMessage(error);
  }, [error]);
  var requiredColor = isInvalid ? {
    color: 'danger.500'
  } : {};
  return jsx(MotionConfig, {
    transition: isMotionReduced ? {
      duration: 0
    } : motion$2.framer.tight,
    children: jsxs(MotionFormControl, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
      animate: isInvalid ? 'invalid' : 'valid',
      as: isLabeled && label ? 'fieldset' : 'div',
      initial: false,
      isInvalid: isInvalid,
      ref: ref,
      variants: invalidVariants,
      children: [label && jsx(FormLabel, {
        as: isLabeled ? 'legend' : 'label',
        htmlFor: id,
        requiredIndicator: jsx(RequiredIndicator, {
          sx: requiredColor,
          children: requiredLabel
        }),
        sx: requiredColor,
        children: label
      }), jsx(FormErrorMessage, {
        bottom: spacingBottom,
        position: "absolute",
        children: errorMessage
      }), /*#__PURE__*/cloneElement(child, inputProps), note && jsx(FormHelperText, {
        children: note
      })]
    }))
  });
});
Field.displayName = 'Field'; // TODO(1.0): 1.0 remove `autohide` entirely

var FieldWithDeprecationWarning = /*#__PURE__*/deprecate(process.env.NODE_ENV !== "production" && {
  autohide: 'the `autohide` prop is deprecated and no longer hides the label',
  disabled: 'the `disabled` prop is deprecated, use `isDisabled`'
}, Field);

var focusProps = /*#__PURE__*/_objectSpread2({
  _groupFocus: {
    color: 'primary.600',
    paintOrder: 'stroke',
    strokeLinejoin: 'round',
    strokeLinecap: 'round',
    strokeWidth: '4px',
    stroke: 'primary.600',
    strokeOpacity: '0.2'
  },
  strokeOpacity: '0',
  strokeWidth: '0'
}, /*#__PURE__*/transitions(['stroke-width', 'color', 'stroke-opacity', 'transform'], motion$2.easings[250]));

var IconFocus = function IconFocus(_ref) {
  var children = _ref.children;
  var child = Children.only(children);

  var props = _objectSpread2(_objectSpread2({}, focusProps), child.props);

  return jsx(Fragment, {
    children: /*#__PURE__*/cloneElement(child, props)
  });
};

var _excluded$g = ["gap", "icon", "size", "onPointerDown", "onPointerUp"],
    _excluded2 = ["max", "min", "onChange", "onInvalid", "step", "value"];
var iconSizes = {
  tiny: 'tiny',
  small: 'small',
  "default": 'small'
};
var StepperButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _after;

  _ref.gap;

  var icon = _ref.icon,
      size = _ref.size,
      onPointerDown = _ref.onPointerDown,
      onPointerUp = _ref.onPointerUp,
      props = _objectWithoutProperties(_ref, _excluded$g);

  var disabled = props.disabled;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDown = _useState2[0],
      setIsDown = _useState2[1];

  var onButtonDown = function onButtonDown(event) {
    setIsDown(true);
    onPointerDown === null || onPointerDown === void 0 ? void 0 : onPointerDown(event);
  };

  var onButtonUp = function onButtonUp(event) {
    setIsDown(false);
    onPointerUp === null || onPointerUp === void 0 ? void 0 : onPointerUp(event);
  };

  return (// TODO: move this styling to the theme
    jsx(chakra.button, _objectSpread2(_objectSpread2(_objectSpread2({
      background: "transparent",
      border: "none",
      borderRadius: "300",
      color: disabled ? 'neutral.400' : 'neutral.600',
      cursor: disabled ? 'default' : 'pointer',
      margin: "50",
      onPointerDown: onButtonDown,
      onPointerUp: onButtonUp,
      padding: "0",
      ref: ref,
      sx: {
        ':hover:not([disabled])': {
          background: isDown ? lighten(0.075, colors.primary[200]) : 'primary.100',
          color: isDown ? 'brandNavy.800' : 'brandNavy.500'
        },
        _after: (_after = {
          borderColor: 'neutral.200',
          borderStyle: 'solid',
          borderWidth: 0,
          borderRightWidth: '400',
          content: '""',
          position: 'absolute'
        }, _defineProperty(_after, icon === faPlus ? 'left' : 'right', 0), _defineProperty(_after, "top", '17.5%'), _defineProperty(_after, "bottom", '17.5%'), _after)
      },
      type: "button"
    }, transitions(['background', 'color'], motion$2.easings[150])), props), {}, {
      children: jsx(IconFocus, {
        children: jsx(AwesomeIcon, {
          icon: icon,
          isStatic: true,
          size: size
        })
      })
    }))
  );
});
var StepperInput = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var max = _ref2.max,
      min = _ref2.min,
      onChange = _ref2.onChange,
      onInvalid = _ref2.onInvalid,
      step = _ref2.step,
      value = _ref2.value,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var _useNumberInput = useNumberInput(_objectSpread2({
    step: step,
    min: min,
    max: max,
    onChange: onChange,
    onInvalid: onInvalid,
    value: value
  }, props)),
      getInputProps = _useNumberInput.getInputProps,
      getIncrementButtonProps = _useNumberInput.getIncrementButtonProps,
      getDecrementButtonProps = _useNumberInput.getDecrementButtonProps;

  var _props$size = props.size,
      size = _props$size === void 0 ? 'default' : _props$size;

  var _splitLayoutProps = splitLayoutProps(props),
      layoutProps = _splitLayoutProps.layoutProps,
      inputProps = _splitLayoutProps.props;

  var inputGroupProps = _objectSpread2(_objectSpread2({}, layoutProps), pickThemingProps(props));

  var buttonSize = mapResponsive(function (s) {
    return iconSizes[s];
  }, size, 'small');
  var buttonPadding = mapResponsive(function (s) {
    return s === 'default' ? '100' : '0';
  }, size, '0');
  return jsxs(InputGroup, _objectSpread2(_objectSpread2({}, inputGroupProps), {}, {
    children: [jsx(InputLeftElement, {
      children: jsx(StepperButton, _objectSpread2(_objectSpread2({}, getDecrementButtonProps()), {}, {
        "aria-label": "Subtract ".concat(step !== null && step !== void 0 ? step : '1'),
        "data-test-id": "stepper-styled-subtract-button",
        icon: faMinus,
        padding: buttonPadding,
        size: buttonSize
      }))
    }), jsx(Input, _objectSpread2(_objectSpread2(_objectSpread2({
      inputMode: "decimal",
      textAlign: "center",
      type: "number"
    }, getInputProps()), inputProps), {}, {
      ref: ref
    })), jsx(InputRightElement, {
      children: jsx(StepperButton, _objectSpread2(_objectSpread2({}, getIncrementButtonProps()), {}, {
        "aria-label": "Add ".concat(step !== null && step !== void 0 ? step : '1'),
        "data-test-id": "stepper-styled-add-button",
        icon: faPlus,
        padding: buttonPadding,
        size: buttonSize
      }))
    })]
  }));
});
StepperInput.displayName = 'StepperInput';
var _excluded$f = ["children", "description", "isSubtle", "isTruncated", "sx"];

var createControl = function createControl(Control) {
  return forwardRef(function (_ref, ref) {
    var children = _ref.children,
        description = _ref.description,
        isSubtle = _ref.isSubtle,
        isTruncated = _ref.isTruncated,
        sx = _ref.sx,
        props = _objectWithoutProperties(_ref, _excluded$f);

    var styles = useMultiStyleConfig('TileControl', props);
    return jsxs(Control, _objectSpread2(_objectSpread2({}, props), {}, {
      cursor: props.isDisabled ? 'default' : 'pointer',
      "data-group": true,
      display: "grid",
      ref: ref,
      sx: _objectSpread2(_objectSpread2({}, styles.container), sx),
      variant: isSubtle ? 'subtle-tile' : 'tile',
      children: [jsx(chakra.span, {
        isTruncated: isTruncated,
        sx: styles.label,
        children: children
      }), description && jsx(Body, {
        as: "span",
        className: "blueprint-tile-control__container",
        isTruncated: isTruncated,
        size: 500,
        sx: styles.description,
        children: description
      })]
    }));
  });
};

var TileCheckbox = /*#__PURE__*/createControl(Checkbox);
var TileRadio = /*#__PURE__*/createControl(Radio);
Editable.displayName = 'Editable';
EditableInput.displayName = 'EditableInput';
EditableTextarea.displayName = 'EditableTextarea';
EditablePreview.displayName = 'EditablePreview';
var _excluded$e = ["sx"];
var TabHeading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded$e);

  var _useStyles = useStyles(),
      heading = _useStyles.heading;

  return jsx(Heading, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    sx: _objectSpread2(_objectSpread2({}, heading), sx)
  }));
});
TabHeading.displayName = 'TabHeading';
Tabs.displayName = 'Tabs';
TabList.displayName = 'TabList';
TabPanels.displayName = 'TabPanels';
Tab.displayName = 'Tab';
TabPanel.displayName = 'TabPanel';
var MenuButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var menuButtonProps = useMenuButton(props, ref);
  return jsx(ButtonWithDeprecationWarning, _objectSpread2(_objectSpread2({
    iconAfter: faChevronDown,
    paddingX: 300,
    shape: "box"
  }, props), menuButtonProps));
});
MenuButton.displayName = 'MenuButton';
var _excluded$d = ["children", "inPortal", "sx", "trigger"];
/**
 * Checks whether the `trigger` component is a `MenuButton`, otherwise add the
 * `as={MenuButton}` prop to the custom trigger component so that it works
 * properly with `Menu`
 *
 * @param trigger trigger component
 */

var getTrigger = function getTrigger(trigger) {
  // If we had some way to actually verify the passed `trigger` supports the
  // `as` prop, we'd wanna do that here too, but unfortunately this is all we
  // can guard against
  !!isIntrinsicElement(trigger) ? process.env.NODE_ENV !== "production" ? invariant(false, componentMessage('Menu', '`trigger` element must be a system component (it must support the `as` prop)')) : invariant(false) : void 0;
  if (trigger.type === MenuButton) return trigger;
  return /*#__PURE__*/cloneElement(trigger, _objectSpread2(_objectSpread2({}, trigger.props), {}, {
    as: MenuButton$1
  }));
};

var Menu = function Menu(_ref) {
  var children = _ref.children,
      inPortal = _ref.inPortal,
      sx = _ref.sx,
      trigger = _ref.trigger,
      props = _objectWithoutProperties(_ref, _excluded$d);

  var _splitSystemProps = splitSystemProps(props),
      menuProps = _splitSystemProps.props,
      systemProps = _splitSystemProps.systemProps;

  var list = jsx(MenuList, _objectSpread2(_objectSpread2({}, systemProps), {}, {
    sx: sx,
    children: children
  }));
  return jsxs(Menu$1, _objectSpread2(_objectSpread2({}, menuProps), {}, {
    children: [getTrigger(trigger), inPortal ? jsx(Portal, {
      children: list
    }) : list]
  }));
};

Menu.displayName = 'Menu';
var _excluded$c = ["checkColor", "sx"];
var MenuItemOption = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checkColor = _ref.checkColor,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded$c);

  var isChecked = props.isChecked,
      isDisabled = props.isDisabled;
  var wrapperStylesChecked = {
    opacity: '1 !important'
  };
  var wrapperStylesUnchecked = {
    transitionProperty: 'opacity',
    transitionDuration: '0.15s',
    transitionTimingFunction: 'ease-in'
  };
  return jsx(MenuItemOption$1, _objectSpread2(_objectSpread2({
    sx: _objectSpread2(_objectSpread2({}, sx), {}, {
      '& .chakra-menu__icon-wrapper': _objectSpread2({
        height: 100
      }, isChecked ? wrapperStylesChecked : wrapperStylesUnchecked)
    })
  }, props), {}, {
    icon: jsx(Check, {
      isChecked: isChecked,
      isDisabled: isDisabled,
      sx: {
        fill: 'none',
        stroke: checkColor !== null && checkColor !== void 0 ? checkColor : 'neutral.600'
      },
      width: "100"
    }),
    ref: ref
  }));
});
MenuItemOption.id = 'MenuItemOption';
MenuCommand.displayName = 'MenuCommand';
MenuDivider.displayName = 'MenuDivider';
MenuGroup.displayName = 'MenuGroup';
MenuIcon.displayName = 'MenuIcon';
MenuItem.displayName = 'MenuItem';
MenuOptionGroup.displayName = 'MenuOptionGroup';

var renderFooter = function renderFooter(footer) {
  if (isLayoutElement(footer)) {
    return /*#__PURE__*/cloneElement(footer, _objectSpread2(_objectSpread2({}, footer.props), {}, {
      as: ModalFooter
    }));
  } // NOTE: for some reason a fragment is required to render a text child here
  // TODO(1.0): consider narrowing type to alleviate this as I'm not sure it
  // makes sense to support text-only content in the footer
  // eslint-disable-next-line react/jsx-no-useless-fragment


  var content = typeof footer === 'string' ? jsx(Fragment, {
    children: footer
  }) : footer;
  return jsx(HStack, {
    as: ModalFooter,
    spacing: "400",
    children: content
  });
};

var OverlayContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      Content = _ref.component,
      contentProps = _ref.contentProps,
      footer = _ref.footer,
      header = _ref.header,
      _ref$isClosable = _ref.isClosable,
      isClosable = _ref$isClosable === void 0 ? true : _ref$isClosable,
      _ref$isOverlay = _ref.isOverlay,
      isOverlay = _ref$isOverlay === void 0 ? true : _ref$isOverlay,
      maxContentHeight = _ref.maxContentHeight;
  return jsxs(Fragment, {
    children: [isOverlay && jsx(ModalOverlay, {
      "data-testid": "overlay"
    }), jsxs(Content, _objectSpread2(_objectSpread2({}, contentProps), {}, {
      ref: ref,
      children: [header && jsx(ModalHeader, {
        children: header
      }), jsx(ModalBody, {
        maxHeight: maxContentHeight,
        children: children
      }), footer && renderFooter(footer), isClosable && jsx(ModalCloseButton, {
        variant: "minimal"
      })]
    }))]
  });
});
OverlayContent.displayName = 'OverlayContent';
var _excluded$b = ["contentProps", "children", "header", "footer", "isClosable", "isOverlay"];

var Drawer = function Drawer(_ref) {
  var contentProps = _ref.contentProps,
      children = _ref.children,
      header = _ref.header,
      footer = _ref.footer,
      _ref$isClosable = _ref.isClosable,
      isClosable = _ref$isClosable === void 0 ? true : _ref$isClosable,
      _ref$isOverlay = _ref.isOverlay,
      isOverlay = _ref$isOverlay === void 0 ? true : _ref$isOverlay,
      props = _objectWithoutProperties(_ref, _excluded$b);

  var isOverlayProps = isOverlay ? {} : {
    closeOnOverlayClick: false,
    trapFocus: false,
    variant: 'persistent'
  };
  return jsx(Drawer$1, _objectSpread2(_objectSpread2(_objectSpread2({}, isOverlayProps), props), {}, {
    children: jsx(OverlayContent, {
      component: DrawerContent,
      contentProps: contentProps,
      footer: footer,
      header: header,
      isClosable: isClosable,
      isOverlay: isOverlay,
      children: children
    })
  }));
};

Drawer.displayName = 'Drawer';
var _excluded$a = ["colorScheme", "defaultValue", "filters", "label", "onChange", "type", "value"];

var FilterMenu = function FilterMenu(_ref) {
  var _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? 'primary' : _ref$colorScheme,
      defaultValue = _ref.defaultValue,
      filters = _ref.filters,
      label = _ref.label,
      onChange = _ref.onChange,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded$a);

  var _useControllableState = useControllableState({
    value: value,
    defaultValue: defaultValue,
    onChange: onChange
  }),
      _useControllableState2 = _slicedToArray(_useControllableState, 2),
      internalValue = _useControllableState2[0],
      setInternalValue = _useControllableState2[1];

  var onMenuOptionGroupChange = function onMenuOptionGroupChange(newValue) {
    return setInternalValue(newValue);
  };

  return jsx(Menu, _objectSpread2(_objectSpread2({
    closeOnSelect: false
  }, props), {}, {
    trigger: jsxs(ButtonWithDeprecationWarning, {
      color: colorScheme,
      "data-group": true,
      fill: "outline",
      iconBefore: iFilter,
      label: filters.map(function (filter) {
        return filter.label;
      }).join(','),
      px: 200,
      shape: "box",
      children: [jsx("span", {
        children: label
      }), jsx(Code, _objectSpread2(_objectSpread2({
        _groupHover: {
          bg: 'primary.200'
        },
        borderRadius: "200",
        colorScheme: colorScheme,
        ml: 200,
        size: 300
      }, transitions(['background'], motion$2.easings[250])), {}, {
        children: Array.isArray(internalValue) ? internalValue.length : '1'
      }))]
    }),
    children: jsx(MenuOptionGroup, {
      onChange: onMenuOptionGroupChange,
      type: type,
      value: internalValue,
      children: filters.map(function (filter) {
        return jsx(MenuItemOption, {
          value: filter.value,
          children: filter.label
        }, filter.value);
      })
    })
  }));
};

var _excluded$9 = ["children", "color", "isLoading", "isAnimated"];
var presence = {
  animate: 'loading',
  exit: 'hidden',
  initial: 'hidden'
};
var MotionLoader = /*#__PURE__*/motion$1(Loader);
var MotionCenter = /*#__PURE__*/motion$1(Center);
var LoadingOverlay = /*#__PURE__*/forwardRef(function (_ref, ref) {
  _ref.children;

  var color = _ref.color,
      isLoading = _ref.isLoading,
      _ref$isAnimated = _ref.isAnimated,
      isAnimatedProp = _ref$isAnimated === void 0 ? true : _ref$isAnimated,
      props = _objectWithoutProperties(_ref, _excluded$9);

  var modal = useModal({
    isOpen: true,
    onClose: function onClose() {}
  });
  var isMotionReduced = useIsMotionReduced();
  var isAnimated = !isMotionReduced && isAnimatedProp;
  var overlayVariants = {
    loading: {
      opacity: 1
    },
    hidden: {
      opacity: 0
    }
  };
  var loaderVariants = stripMotionFromVariants({
    loading: {
      opacity: 1,
      transform: 'translate3d(0, 0%, 0)'
    },
    hidden: {
      opacity: 0,
      transform: 'translate3d(0, 50%, 0)'
    }
  }, !isAnimated);
  return jsx(ModalContextProvider, {
    value: _objectSpread2({
      returnFocusOnClose: true
    }, modal),
    children: jsx(MotionConfig, {
      transition: theme.motion.framer.firm,
      children: jsx(Portal, _objectSpread2(_objectSpread2({}, props), {}, {
        children: jsx(BoxWithDeprecationWarning, {
          position: "fixed",
          top: "0",
          zIndex: "loading",
          children: jsx(AnimatePresence, {
            children: isLoading && jsx(MotionCenter, _objectSpread2(_objectSpread2({
              background: "overlayLight",
              "data-testid": "loading-overlay",
              height: "100vh",
              ref: ref,
              variants: overlayVariants,
              width: "100vw"
            }, presence), {}, {
              children: jsx(ModalFocusScope, {
                children: jsx(MotionLoader, _objectSpread2({
                  color: color,
                  size: "huge",
                  variants: loaderVariants
                }, presence))
              })
            }))
          })
        })
      }))
    })
  });
});
LoadingOverlay.displayName = 'LoadingOverlay';
var _excluded$8 = ["contentProps", "children", "header", "footer", "isClosable", "maxContentHeight"];
var Modal = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var contentProps = _ref.contentProps,
      children = _ref.children,
      header = _ref.header,
      footer = _ref.footer,
      _ref$isClosable = _ref.isClosable,
      isClosable = _ref$isClosable === void 0 ? true : _ref$isClosable,
      maxContentHeight = _ref.maxContentHeight,
      props = _objectWithoutProperties(_ref, _excluded$8);

  return jsx(Modal$1, _objectSpread2(_objectSpread2({}, props), {}, {
    children: jsx(OverlayContent, {
      component: ModalContent,
      contentProps: contentProps,
      footer: footer,
      header: header,
      isClosable: isClosable,
      maxContentHeight: maxContentHeight,
      ref: ref,
      children: children
    })
  }));
});
Modal.displayName = 'Modal';
var _excluded$7 = ["bodyProps", "children", "footer", "header", "inPortal", "isClosable", "isHover", "showClose", "sx", "trigger"];

var Popover = function Popover(_ref) {
  var bodyProps = _ref.bodyProps,
      children = _ref.children,
      footer = _ref.footer,
      header = _ref.header,
      inPortal = _ref.inPortal,
      isClosableProp = _ref.isClosable,
      isHover = _ref.isHover,
      showClose = _ref.showClose,
      sx = _ref.sx,
      trigger = _ref.trigger,
      props = _objectWithoutProperties(_ref, _excluded$7);

  var isClosable = showClose !== null && showClose !== void 0 ? showClose : isClosableProp;

  var _splitSystemProps = splitSystemProps(props),
      menuProps = _splitSystemProps.props,
      systemProps = _splitSystemProps.systemProps;

  var content = function content(renderPropProps) {
    return (// @ts-ignore
      jsxs(PopoverContent, _objectSpread2(_objectSpread2({}, systemProps), {}, {
        sx: sx,
        children: [jsx(PopoverArrow, {}), isClosable && jsx(PopoverCloseButton, {
          size: "small",
          variant: "minimal"
        }), header && jsx(PopoverHeader, {
          children: invoke(header, renderPropProps)
        }), jsx(PopoverBody, _objectSpread2(_objectSpread2({}, bodyProps), {}, {
          children: invoke(children, renderPropProps)
        })), footer && jsx(PopoverFooter, {
          children: invoke(footer, renderPropProps)
        })]
      }))
    );
  };

  return jsx(Popover$1, _objectSpread2(_objectSpread2({
    trigger: isHover ? 'hover' : 'click'
  }, menuProps), {}, {
    children: function children(renderPropProps) {
      return jsxs(Fragment, {
        children: [jsx(PopoverTrigger, {
          children: trigger
        }), inPortal ? jsx(Portal, {
          children: content(renderPropProps)
        }) : content(renderPropProps)]
      });
    }
  }));
};

Popover.displayName = 'Popover';
var _excluded$6 = ["children", "sx"];
var Tooltip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded$6); // Chakra doesn't really provide any way to customize the default tooltip
  // animation, and because it uses scale and opacity it isn't disabled by
  // default by Framer's `reducedMotion` setting, so we have to override it
  // with CSS to effectively remove the motion here


  var reducedMotionStyles = useIsMotionReduced() ? {
    transform: 'scale(1) !important',
    opacity: '1 !important'
  } : {};
  return jsx(Tooltip$1, _objectSpread2(_objectSpread2({
    hasArrow: true,
    placement: "bottom"
  }, props), {}, {
    ref: ref,
    sx: _objectSpread2(_objectSpread2({}, reducedMotionStyles), sx),
    children: children
  }));
});
Tooltip.displayName = 'Tooltip';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Image = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var props = _extends({}, _ref);

  return jsx(Image$1, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
    ref: ref
  }));
});
Image.displayName = 'Image';
var _excluded$5 = ["defaultValue", "disabled", "initialValue", "isDisabled", "label", "max", "value", "min", "onChange", "snapThreshold", "step", "suggestedValue"];
var Slider = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2;

  var defaultValueProp = _ref.defaultValue,
      disabled = _ref.disabled,
      initialValue = _ref.initialValue,
      isDisabledProp = _ref.isDisabled,
      label = _ref.label,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      value = _ref.value,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      onChange = _ref.onChange,
      snapThreshold = _ref.snapThreshold,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      suggestedValue = _ref.suggestedValue,
      props = _objectWithoutProperties(_ref, _excluded$5);

  var defaultValue = (_ref2 = defaultValueProp !== null && defaultValueProp !== void 0 ? defaultValueProp : initialValue) !== null && _ref2 !== void 0 ? _ref2 : 0;
  var isDisabled = isDisabledProp !== null && isDisabledProp !== void 0 ? isDisabledProp : disabled;
  var styles = useMultiStyleConfig('Slider', props);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDragging = _useState2[0],
      setIsDragging = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isControlPressed = _useState4[0],
      setIsControlPressed = _useState4[1];

  var _useControllableState = useControllableState({
    value: value,
    defaultValue: defaultValue,
    onChange: onChange
  }),
      _useControllableState2 = _slicedToArray(_useControllableState, 2),
      computedValue = _useControllableState2[0],
      setValue = _useControllableState2[1];

  var onSliderChange = function onSliderChange(updatedValue) {
    if (suggestedValue && snapThreshold && isDragging && !isControlPressed && updatedValue >= suggestedValue - snapThreshold && updatedValue <= suggestedValue + snapThreshold) {
      return setValue(suggestedValue);
    }

    return setValue(updatedValue);
  };

  var onSliderChangeStart = function onSliderChangeStart(event) {
    var _props$onChangeStart;

    (_props$onChangeStart = props.onChangeStart) === null || _props$onChangeStart === void 0 ? void 0 : _props$onChangeStart.call(props, event);
    setIsDragging(true);
  };

  var onSliderChangeEnd = function onSliderChangeEnd(event) {
    var _props$onChangeEnd;

    (_props$onChangeEnd = props.onChangeEnd) === null || _props$onChangeEnd === void 0 ? void 0 : _props$onChangeEnd.call(props, event);
    setIsDragging(false);
  };

  var onWindowKeyDown = function onWindowKeyDown(event) {
    return event.ctrlKey && setIsControlPressed(true);
  };

  var onWindowKeyUp = function onWindowKeyUp(event) {
    return !event.ctrlKey && setIsControlPressed(false);
  };

  useEffect(function () {
    if (isDisabled && suggestedValue && computedValue !== suggestedValue) {
      setValue(suggestedValue);
    }
  }, [computedValue, isDisabled, setValue, suggestedValue]);
  useEffect(function () {
    if (suggestedValue && snapThreshold) {
      window.addEventListener('keydown', onWindowKeyDown);
      window.addEventListener('keyup', onWindowKeyUp);
      return function () {
        window.removeEventListener('keydown', onWindowKeyDown);
        window.removeEventListener('keyup', onWindowKeyUp);
      };
    }

    return undefined;
  }, [snapThreshold, suggestedValue]);
  var isSuggested = suggestedValue ? Math.round(suggestedValue) === Math.round(computedValue) : false;
  return jsxs(Slider$1, _objectSpread2(_objectSpread2({
    "aria-label": label,
    isDisabled: isDisabled,
    max: max,
    min: min,
    onChange: onSliderChange,
    onChangeEnd: onSliderChangeEnd,
    onChangeStart: onSliderChangeStart,
    step: step,
    value: computedValue
  }, props), {}, {
    ref: ref,
    children: [jsx(SliderTrack, {}), suggestedValue && jsx(SliderMark, {
      __css: styles.suggestedValueTrack,
      "data-filled": computedValue >= suggestedValue ? '' : undefined,
      value: suggestedValue
    }), jsx(SliderFilledTrack, {}), suggestedValue && jsx(SliderMark, {
      __css: styles.suggestedValue,
      value: suggestedValue
    }), jsx(SliderThumb, _objectSpread2({
      "data-suggested": isSuggested ? '' : undefined
    }, suggestedValue !== undefined ? {
      'aria-details': "Suggested value ".concat(suggestedValue)
    } : {}))]
  }));
});
Slider.displayName = 'Slider'; // TODO(1.0): 1.0 remove `initialValue` and `disabled` entirely

var SliderWithDeprecationWarning = /*#__PURE__*/deprecate(process.env.NODE_ENV !== "production" && {
  disabled: 'the `disabled` prop is deprecated, use `isDisabled`',
  initialValue: 'the `initialValue` prop is deprecated, use `defaultValue`'
}, Slider);
var _excluded$4 = ["defaultChecked", "defaultValue", "disabled", "error", "isChecked", "isDisabled", "isInvalid", "onValueChange", "size", "value"];
var Toggle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var defaultCheckedProp = _ref.defaultChecked,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      error = _ref.error,
      isCheckedProp = _ref.isChecked,
      isDisabledProp = _ref.isDisabled,
      isInvalidProp = _ref.isInvalid,
      onValueChange = _ref.onValueChange,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      valueProp = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded$4); // TODO(1.0): this is pretty gross, but for now we're preserving the original
  // `Toggle` behavior in which `value` and `defaultValue` control what is
  // now `isChecked` and `defaultChecked` respectively.


  var isChecked = isCheckedProp !== null && isCheckedProp !== void 0 ? isCheckedProp : typeof valueProp === 'boolean' ? valueProp : undefined;
  var value = typeof valueProp !== 'boolean' ? valueProp : undefined;
  var defaultChecked = defaultCheckedProp !== null && defaultCheckedProp !== void 0 ? defaultCheckedProp : defaultValue;
  var isDisabled = isDisabledProp !== null && isDisabledProp !== void 0 ? isDisabledProp : disabled;
  var isInvalid = isInvalidProp !== null && isInvalidProp !== void 0 ? isInvalidProp : error;

  var onElementChange = function onElementChange(event) {
    var _props$onChange;

    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(event.target.checked);
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, event);
  };

  return jsx(Switch, _objectSpread2(_objectSpread2({
    defaultChecked: defaultChecked,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isInvalid: isInvalid,
    onChange: onElementChange,
    size: size,
    value: value
  }, withTestId(props)), {}, {
    ref: ref
  }));
});
Toggle.displayName = 'Toggle';
var _excluded$3 = ["children"];
var Badge = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$3);

  return jsx(Badge$1, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    children: children
  }));
});
Badge.displayName = 'Badge';
var _excluded$2 = ["children", "colorScheme"];
var Blockquote = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? 'primary' : _ref$colorScheme,
      props = _objectWithoutProperties(_ref, _excluded$2);

  return jsx(Alert, _objectSpread2(_objectSpread2({
    as: "blockquote",
    colorScheme: colorScheme
  }, withTestId(props)), {}, {
    position: "relative",
    ref: ref,
    variant: "quote",
    children: jsxs(ColorSchemeProvider, {
      colorScheme: colorScheme,
      variant: "dark",
      children: [jsx(chakra.div, {
        bg: colorScheme === 'brandTan' ? 'brandTan.400' : "".concat(colorScheme, ".200"),
        bottom: 0,
        left: 0,
        position: "absolute",
        top: 0,
        width: 50
      }), jsx(AlertDescription, {
        children: children
      })]
    })
  }));
});
Blockquote.displayName = 'Blockquote';
var _excluded$1 = ["children", "title", "showIndentation"];

var BorderIcon = function BorderIcon() {
  return jsx(BoxWithDeprecationWarning, {
    "aria-hidden": "true",
    backgroundColor: "neutral.400",
    borderRadius: "2",
    flexShrink: 0,
    height: "inherit",
    marginRight: "300",
    width: "25"
  });
};

var Collapse = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$showIndentation = _ref.showIndentation,
      showIndentation = _ref$showIndentation === void 0 ? true : _ref$showIndentation,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return jsx(Accordion, _objectSpread2(_objectSpread2({
    allowToggle: true,
    whiteSpace: "normal"
  }, props), {}, {
    children: jsxs(AccordionItem, {
      border: "none",
      width: "100%",
      children: [jsxs(AccordionButton, _objectSpread2(_objectSpread2({}, textSizes[500]), {}, {
        _focus: {
          border: 'none'
        },
        _hover: {
          bgColor: 'none',
          cursor: 'pointer'
        },
        background: "transparent",
        border: "none",
        color: "neutral.text",
        "data-group": true,
        fontFamily: "body",
        fontWeight: "body",
        marginBottom: "3px",
        padding: "0",
        ref: ref,
        children: [title, jsx(IconFocus, {
          children: jsx(AccordionIcon, {
            color: "neutral.400",
            height: "200",
            marginLeft: "100",
            width: "200"
          })
        })]
      })), jsx(AccordionPanel, _objectSpread2(_objectSpread2({}, textSizes[500]), {}, {
        color: "neutral.600",
        fontFamily: "body",
        fontWeight: "body",
        padding: "0",
        children: jsxs(BoxWithDeprecationWarning, {
          children: [showIndentation && jsx(BorderIcon, {}), children]
        })
      }))]
    })
  }));
});
Collapse.displayName = 'Collapse';
Table.displayName = 'Table';
Tbody.displayName = 'Tbody';
Td.displayName = 'Td';
Tfoot.displayName = 'Tfoot';
Th.displayName = 'Th';
Thead.displayName = 'Thead';
Tr.displayName = 'Tr';

var TagCloseIcon = function TagCloseIcon(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return jsx(Icon, {
    height: height,
    verticalAlign: "inherit",
    viewBox: "0 0 12 12",
    width: width,
    children: jsx("path", {
      d: "M0.219546 10.7188C0.0789261 10.8595 -4.68466e-05 11.0503 3.66621e-08 11.2492C4.69199e-05 11.4481 0.0791097 11.6389 0.219796 11.7795C0.360481 11.9201 0.551266 11.999 0.750179 11.999C0.949092 11.999 1.13984 11.9199 1.28046 11.7792L5.91108 7.14929C5.92269 7.13765 5.93648 7.12841 5.95167 7.12211C5.96685 7.11581 5.98313 7.11257 5.99957 7.11257C6.01601 7.11257 6.03229 7.11581 6.04748 7.12211C6.06266 7.12841 6.07646 7.13765 6.08807 7.14929L10.7187 11.7802C10.7883 11.8499 10.871 11.9051 10.962 11.9428C11.053 11.9806 11.1505 12 11.249 12C11.3475 12 11.445 11.9806 11.536 11.943C11.627 11.9053 11.7097 11.8501 11.7794 11.7805C11.849 11.7108 11.9043 11.6282 11.942 11.5372C11.9797 11.4462 11.9991 11.3487 11.9991 11.2502C11.9992 11.1517 11.9798 11.0542 11.9421 10.9632C11.9045 10.8722 11.8492 10.7895 11.7796 10.7198L7.14948 6.08792C7.13784 6.07631 7.1286 6.06251 7.1223 6.04733C7.116 6.03215 7.11276 6.01587 7.11276 5.99943C7.11276 5.98299 7.116 5.96671 7.1223 5.95153C7.1286 5.93634 7.13784 5.92255 7.14948 5.91094L11.7806 1.28051C11.9212 1.1397 12.0001 0.948793 12 0.749794C11.9999 0.550796 11.9207 0.360004 11.7799 0.21939C11.639 0.0787765 11.4481 -0.000140445 11.2491 1.87636e-07C11.0501 0.00014082 10.8593 0.0793275 10.7187 0.22014L6.08807 4.84957C6.07646 4.86121 6.06266 4.87044 6.04748 4.87674C6.03229 4.88304 6.01601 4.88629 5.99957 4.88629C5.98313 4.88629 5.96685 4.88304 5.95167 4.87674C5.93648 4.87044 5.92269 4.86121 5.91108 4.84957L1.28046 0.22014C1.21083 0.150482 1.12816 0.0952205 1.03718 0.0575095C0.946193 0.0197985 0.848671 0.000376896 0.750179 0.000353684C0.551266 0.000306805 0.360481 0.0792764 0.219796 0.21989C0.0791097 0.360504 4.69011e-05 0.551243 2.086e-08 0.750148C-4.68594e-05 0.949053 0.078926 1.13983 0.219546 1.28051L4.84967 5.91094C4.86131 5.92255 4.87054 5.93634 4.87684 5.95153C4.88314 5.96671 4.88639 5.98299 4.88639 5.99943C4.88639 6.01587 4.88314 6.03215 4.87684 6.04733C4.87054 6.06251 4.86131 6.07631 4.84967 6.08792L0.219546 10.7188Z",
      fill: "currentColor"
    })
  });
};

var _excluded = ["children", "showClose", "icon"];
var Tag = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      showClose = _ref.showClose,
      icon = _ref.icon,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('Tag', props);
  return jsxs(Tag$1, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    children: [icon && jsx(TagLeftIcon, {
      __css: styles.icon,
      as: AwesomeIcon,
      icon: icon,
      margin: "0"
    }), jsx(TagLabel, {
      children: children
    }), showClose && jsx(TagCloseButton, {
      children: jsx(TagCloseIcon, {})
    })]
  }));
});
Tag.displayName = 'Tag';
/**
 * Conditionally preserve legacy typography
 *
 * @param theme Chakra theme
 * @param newTypography whether new typography is enabled
 */

var applyLegacyTypography = function applyLegacyTypography(theme, newTypography) {
  return newTypography ? theme : extendTheme(legacyTypography, theme);
};

var Provider = function Provider(_ref) {
  var children = _ref.children,
      customTheme = _ref.customTheme,
      environment = _ref.environment,
      fontsHost = _ref.fontsHost,
      _ref$includeFonts = _ref.includeFonts,
      includeFonts = _ref$includeFonts === void 0 ? false : _ref$includeFonts,
      _ref$newTypography = _ref.newTypography,
      newTypography = _ref$newTypography === void 0 ? true : _ref$newTypography,
      portalZIndex = _ref.portalZIndex,
      _ref$resetCSS = _ref.resetCSS,
      resetCSS = _ref$resetCSS === void 0 ? false : _ref$resetCSS;
  /**
   * Adds support for responsive `size` props on specified components
   *
   * @see `src/helpers/responsive`
   */

  var responsiveChakraTheme = makeThemeResponsive(customTheme !== null && customTheme !== void 0 ? customTheme : theme, ['Button', 'Code', 'Decoration', 'Heading', 'Icon', 'Link', 'Text']);
  return jsxs(ChakraProvider, {
    environment: environment,
    portalZIndex: portalZIndex,
    resetCSS: resetCSS,
    theme: applyLegacyTypography(responsiveChakraTheme, newTypography),
    children: [includeFonts && jsx(Fonts, {
      host: fontsHost,
      includeLegacy: includeFonts === 'all' || !newTypography,
      includeNew: includeFonts === 'all' || newTypography
    }), jsx(Provider$1, {
      value: {
        theme: theme$1
      },
      children: children
    })]
  });
};

export { Body as B, Collapse as C, Drawer as D, Fonts as F, Heading as H, Image as I, LoadingOverlay as L, Message as M, Panel as P, SliderWithDeprecationWarning as S, TileCheckbox as T, _extends as _, Toggle as a, Badge as b, Blockquote as c, Tag as d, Provider as e, Checkbox as f, FieldWithDeprecationWarning as g, Select as h, StepperInput as i, TextInputWithDeprecationWarning as j, TileRadio as k, TabHeading as l, FilterMenu as m, Modal as n, Popover as o, Tooltip as p, Menu as q, MenuButton as r, MenuItemOption as s, Code as t, useChakraTheme as u, useReducedMotionVariants as v, useTheme as w, useTimeoutFlag as x, motion as y };